import React from 'react'
import { useParams } from 'react-router'

export default function SponsorPackageBody({ items }) {
  const { lng } = useParams()
  return (
    <div>
      <ol className={`mb-2 flex min-h-[500px] list-inside list-decimal flex-col gap-4 border-x-2 border-b-2 border-muted-300 p-4`}>
        {items.map((item) => (
          <li key={item.id}>{item[`text_${lng}`]}</li>
        ))}
      </ol>
    </div>
  )
}